(function () {
  'use strict';

  function companyFormNcp () {
    return {
      restrict: 'E',
      templateUrl: 'components/payment/forms/company-form-ncp.html'
    };
  }

  angular.module('web2print.payment')
    .directive('companyFormNcp', companyFormNcp);
})();
